export default {"src":"/_next/static/media/next.ad758a18.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};